import { useContext, useMemo, useState } from 'react'
import { Navigate, useLocation, useNavigate, useParams } from 'react-router-dom'
import _ from 'lodash'

import { AppContext } from '/providers/app-context'
import ManagePassSubpageLayout from '/components/passes/manage-pass-subpage-layout'
import { PassEditContent } from '/components/passes/editor'
import HelpText from '/help/pass-editor'

const SelectedPassesEditor = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const { templateId } = useParams()
  const { templates, setPasses } = useContext(AppContext)
  const [selection, setSelection] = useState(() => location.state?.selection ?? {
    type: 'loaded',
    count: location.state?.passes?.length ?? 0,
    mode: 'live',
    passes: location.state?.passes ?? [],
  })
  const template = useMemo(() => templates.find(item => item.template_id === templateId), [templateId, templates])
  const selectedPasses = selection.type === 'allMatching' ? selection.loadedPasses : selection.passes

  if (selection.count < 2) return <Navigate to={`/templates/${templateId}/passes`} replace />

  const applyLocalPatch = variables => {
    const selectedIds = new Set(selectedPasses.map(pass => pass.pass_id))
    const applyVariables = pass => ({ ...pass, variables: _.merge({}, pass.variables, variables) })

    setSelection(current => ({
      ...current,
      ...(current.type === 'allMatching'
        ? { loadedPasses: current.loadedPasses.map(applyVariables) }
        : { passes: current.passes.map(applyVariables) })
    }))
    setPasses(current => current.map(pass => selectedIds.has(pass.pass_id)
      ? applyVariables(pass)
      : pass
    ))
  }

  return (
    <ManagePassSubpageLayout
      title="Edit Selected Passes"
      HelpText={HelpText}
      heading={`Edit ${selection.count.toLocaleString()} selected passes`}
      template={template}
      selectedPasses={selectedPasses}
      onClose={() => navigate(`/templates/${templateId}/passes`)}
    >
      <PassEditContent passes={selectedPasses} selectionScope={selection} templateId={templateId} onBulkApplied={applyLocalPatch} />
    </ManagePassSubpageLayout>
  )
}

export default SelectedPassesEditor
